export const calendarEvent = [{
    title: 'Stations of the cross',
    date: '2021-02-26',
    start: '2021-02-26T16:00:00.000Z',
    end: '2021-02-26T17:00:00.000Z',
    backgroundColor: 'purple',
    borderColor: 'purple'
  },
  {
    title: 'Stations of the cross',
    date: '2021-03-05T16:00:00.000Z',
    backgroundColor: 'purple',
    borderColor: 'purple'
  },
  {
    title: 'Stations of the cross',
    date: '2021-03-12T16:00:00.000Z',
    backgroundColor: 'purple',
    borderColor: 'purple'
  },

  {
    title: 'Holy Thursday',
    date: '2021-04-01',
    start: '2021-04-01T19:00:00.000Z',
    backgroundColor: 'gold',
    borderColor: 'gold'
  },

  {
    title: 'Good Friday',
    date: '2021-04-02',
    start: '2021-04-02T16:00:00.000Z',
    backgroundColor: 'red',
    borderColor: 'red'
  },

  {
    title: 'Holy Saturday',
    date: '2021-04-03',
    start: '2021-04-03T19:00:00.000Z',
    backgroundColor: 'gold',
    borderColor: 'gold'
  },

  {
    title: 'Life in the Spirit Seminar',
    date: '2021-04-11',
    start: '2021-04-11T10:00:00.000Z',
    backgroundColor: 'red',
    borderColor: 'red'
  },
]



const getAllSundays = (year) => {
  var date = new Date(year, 0, 1);
  while (date.getDay() != 0) {
    date.setDate(date.getDate() + 1);
  }
  //var days = [];
  while (date.getFullYear() == year) {
    let m = date.getMonth() + 1;
    let d = date.getDate();
    let month = (m < 10 ? '0' + m : m)
    let day = (d < 10 ? '0' + d : d)
    let fullDate = year + '-' + month + '-' + day
    let firstMass = {
      title: 'Sunday Mass',
      date: fullDate,
      start: `${fullDate}T06:00:00.000Z`
    }
    let secondMass = {
      title: 'Sunday Mass',
      date: fullDate,
      start: `${fullDate}T08:00:00.000Z`
    }
    let thirdMass = {
      title: 'Sunday Mass',
      date: fullDate,
      start: `${fullDate}T10:00:00.000Z`
    }
    calendarEvent.push(firstMass, secondMass, thirdMass);
    date.setDate(date.getDate() + 7);
  }
}


const getAllThursdays = (year) => {
  debugger
  var date = new Date(year, 0, 1);
  while (date.getDay() != 4) {
    date.setDate(date.getDate() + 1);
  }
 // var days = [];
  while (date.getFullYear() == year) {
    let m = date.getMonth() + 1;
    let d = date.getDate();
    let month = (m < 10 ? '0' + m : m)
    let day = (d < 10 ? '0' + d : d)
    let fullDate = year + '-' + month + '-' + day

    let data = {
      title: 'Eucharistic Adoration',
      date: fullDate,
      start: `${fullDate}T06:00:00.000Z`,
      backgroundColor: 'green',
      borderColor: 'green'
    }
    calendarEvent.push(data);
    date.setDate(date.getDate() + 7);
  }
}
getAllSundays(new Date().getFullYear())
getAllThursdays(new Date().getFullYear())
